import { NavLink, Outlet } from 'react-router-dom';

const menuItems = [
  { routePath: '/ui-kit/colors', title: 'Colors' },
  { routePath: '/ui-kit/icons', title: 'Icons' },
  { routePath: '/ui-kit/input-field', title: 'Input Field' },
  { routePath: '/ui-kit/checkbox-and-radio', title: 'Checkbox & Radio' },
  { routePath: '/ui-kit/autocomplete', title: 'Autocomplete' },
  { routePath: '/ui-kit/button', title: 'Button' },
  { routePath: '/ui-kit/time-picker', title: 'Time Picker' },
  { routePath: '/ui-kit/typography', title: 'Typography' },
  { routePath: '/ui-kit/dialog', title: 'Dialog' },
  { routePath: '/ui-kit/tabs', title: 'Tabs' },
  { routePath: '/ui-kit/snackbar', title: 'Snackbar' },
  { routePath: '/ui-kit/table', title: 'Table' },
  { routePath: '/ui-kit/image-crop-editor', title: 'Image Crop Editor' },
  { routePath: '/ui-kit/media-library', title: 'Media Library' },
  { routePath: '/ui-kit/date-range', title: 'Date Range' },
  { routePath: '/ui-kit/status-select', title: 'Status Select' },
  { routePath: '/ui-kit/info-tooltip', title: 'Info Tooltip' },
  { routePath: '/ui-kit/pagination', title: 'Pagination' },
  { routePath: '/ui-kit/progress-list', title: 'Progress List' },
  { routePath: '/ui-kit/cards', title: 'Cards' },
  { routePath: '/ui-kit/charts', title: 'Charts' },
  { routePath: '/ui-kit/loader', title: 'Loader' }
];

const UiKitContainer = () => {
  return (
    <div className="flex min-h-screen">
      {/* Sidebar */}
      <aside className="w-[250px] border-r border-gray-200 bg-white shadow-lg py-6 px-4 h-[calc(100vh-110px)] overflow-y-auto">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">UI Kit</h2>
        <nav className="flex flex-col gap-2">
          {menuItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.routePath}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-xl text-gray-700 transition-all duration-200
                 ${
                   isActive
                     ? 'bg-gradient-to-r from-[var(--primary-300)] to-[var(--primary-50)] !text-[var(--primary)] font-semibold shadow-inner'
                     : 'hover:bg-gradient-to-r hover:from-[var(--primary-200)] hover:to-[var(--primary-50)] hover:text-[var(--primary)]'
                 }`
              }
            >
              {item.title}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Content Area */}
      <main className="flex-1 h-[calc(100vh-130px)] overflow-y-auto py-8 px-10">
        <Outlet />
      </main>
    </div>
  );
};

export default UiKitContainer;
